




























































































































































import RepairContent from "@/model/repairContent";
import Component from "vue-class-component";
import RepairContentUpdateComponent from "./repairContentUpdateComponent.vue";

@Component({
  name: "RepairContentDetail",
  components: {},
})
export default class RepairContentDetail extends RepairContentUpdateComponent {
  /**
   * show
   */
  public show(repair: RepairContent = null, mode = "edit") {
    this.errors = {};
    this.mod = mode;

    this.repairContent = repair;

    this.isShow = true;
  }
}
